import React from "react";
import { EditorField } from "../../../../store";
import { SelectField, getFieldIcon } from "@codway-dev/ui";

interface InputPreviewProps {
  field: EditorField;
  dynamicStyle: React.CSSProperties;
  onUpdate: (value: string) => void;
  error?: string;
}

export const SelectInputPreview: React.FC<InputPreviewProps> = ({
  field,
  dynamicStyle,
  onUpdate,
  error,
}) => {
  const icon = field.show_icon
    ? getFieldIcon(field.key, field.type)
    : undefined;

  return (
    <div style={dynamicStyle as React.CSSProperties}>
      <SelectField
        label={field.label}
        value={field.defaultValue || ""}
        options={"options" in field ? (field.options ?? []) : []}
        onChange={onUpdate}
        required={field.required}
        error={error}
        icon={icon}
      />
    </div>
  );
};
